import React from 'react';
import './style.scss';
import Icon from '../../../../components/Icon/Icon';
import { Link } from 'react-router-dom';
import MetaInfo from './MetaInfo/MetaInfo';
import imgHero from './i/chicken_hero.jpg';
import imgHeroMobile from './i/mobile/chicken_hero.jpg';
import arrow from '../../../../assets/images/hero-arrow.png';
import chickenSvg from './i/svg/chicken_stamp.svg';
import chickenSvgFr from './i/svg/chicken_stamp_fr.svg';
import SliderWrap from '../../../../components/SliderWrap/SliderWrap';
import slide1 from './i/carousel_chicken_1.jpg';
import slide2 from './i/carousel_chicken_2.jpg';
import slide3 from './i/carousel_chicken_3.jpg';
import slide4 from './i/carousel_chicken_4.jpg';
import slide5 from './i/carousel_chicken_5.jpg';
import IngredientsSlider from '../../../../components/IngredientsSlider/IngredientsSlider';
import MobileOrderBanner from '../../../../components/MobileOrderBanner/MobileOrderBanner';

const Chicken = (props) => {

    return (
        <>
            <MetaInfo {...props} />
            <div className="blockwrap our-food chicken">
                <div className="intro-block">
                    {props.isDesktop ? 
                        <img className="intro-bg-img" src={imgHero} alt="chicken" />
                        : 
                        <img className="intro-bg-img" src={imgHeroMobile} alt="chicken" />
                    }
                </div>

                <div className="copy-block">
                    {/* <h1><span><span className="line"></span> Beef <span className="line"></span></span>something or other</h1> */}
                    
                    {props.lang === 'en' ? <img className="img-svg" src={chickenSvg} alt={"chicken"} /> : <img className="img-svg" src={chickenSvgFr} alt={"chicken"} />}
                    {props.lang === 'en' && <p>At A&W, we believe great food starts from great beginnings. That’s why we only serve chicken raised without antibiotics and fed a grain-based, vegetarian diet with no animal by-products. We’re also proud to say that all of our chicken burgers and strips are made with seasoned, 100% chicken breast. It’s all part of our commitment to serve you food you can feel good&nbsp;about.</p>}
                    {props.lang === 'fr' && <p>Chez A&W, servir des aliments savoureux signifie aussi qu’on se soucie de ce qu’ils contiennent. C’est pourquoi nous servons uniquement du poulet de grain élevé sans antibiotiques et nourri de manière végétarienne, sans aucun sous-produit animal. Nous sommes également fiers de dire que le poulet dans nos burgers et languettes est composé à 100 % de poitrines de poulet assaisonnées. C’est notre engagement à vous servir des aliments que vous pouvez savourer en toute&nbsp;confiance.</p>}
                    <img src={arrow} className="bounce" alt="arrow" />
                </div>

            </div>

            <div className="where-block">
                            
                {props.lang !== 'fr' ?
                    <>
                        <h2>Where does our&nbsp;  
                            <span>chicken come from?</span>
                        </h2>
                    </>
                    :
                    <>
                        <h2>D’où vient notre&nbsp;  
                            <span>poulet?</span>
                        </h2>
                    </>
                }
            </div>
            
            <SliderWrap {...props}>
                <div key="1" className="item">
                    <div className="itemcol">
                        <img src={slide1} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>THE MAY FAMILY - RICHMOND, BC</h3>
                                        <p>All of the chicken we serve comes from family farms throughout British Columbia and Saskatchewan.</p>
                                    </>
                                :
                                    <>
                                        <h3>LA FAMILLE MAY – RICHMOND, C.-B.</h3>
                                        <p>Tout le poulet que nous servons provient de fermes familiales de la Colombie-Britannique et de la Saskatchewan.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="2" className="item">
                    <div className="itemcol">
                        <img src={slide2} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>FULLY VEGETARIAN DIET</h3>
                                        <p>Chickens are humanely raised in large barns, with room to roam and ample access to fresh air and clean water.</p>
                                    </>
                                :
                                    <>
                                        <h3>RÉGIME VÉGÉTARIEN</h3>
                                        <p>Tous nos poulets sont nourris de manière exclusivement végétarienne, sans aucun sous-produit animal.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="3" className="item">
                    <div className="itemcol">
                        <img src={slide3} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>ROOM TO ROAM</h3>
                                        <p>Chickens are humanely raised in large barns, with room to roam and ample access to fresh air and clean water.</p>
                                    </>
                                :
                                    <>
                                        <h3>DE L’ESPACE POUR SE PROMENER</h3>
                                        <p>Les poulets sont élevés sans cruauté dans de grands poulaillers, avec de l’espace pour se promener et un libre accès à de l’eau propre et de l’air frais.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="4" className="item">
                    <div className="itemcol">
                        <img src={slide4} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>BEST PRACTICES</h3>
                                        <p>Our farmers employ the very best practices in every aspect of caring for their chickens.</p>
                                    </>
                                :
                                    <>
                                        <h3>LES MEILLEURES PRATIQUES</h3>
                                        <p>Dans chaque aspect de l’élevage de leurs poulets, nos éleveurs emploient les meilleures pratiques.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
                <div key="5" className="item">
                    <div className="itemcol">
                        <img src={slide5} className="" alt="" /> 
                        <div className="copy-wrap">
                            {props.lang !== 'fr' ? 
                                    <>
                                        <h3>THIRD PARTY AUDITS</h3>
                                        <p>Our chicken barns receive independent, third party audits that focus on overall flock health as well as healthy air quality, climate and lighting conditions.</p>
                                    </>
                                :
                                    <>
                                        <h3>AUDITS D’UNE TIERCE PARTIE</h3>
                                        <p>Nos poulaillers font l’objet d’audits indépendants qui visent à vérifier l’état de santé global des volailles ainsi que la qualité de l’air, du climat et de l’éclairage dans les installations.</p>
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </SliderWrap>

            <div className="blockwrap our-food faq-block chicken">
            
                <Link  className="find-aw"  to={`/${props.lang}/faq/chicken`}>
                    {props.lang !== 'fr' ? 
                        <><span>Chicken</span> FAQ<Icon type=" gt-inverted" /></>
                        :
                        <><span>FAQ sur notre</span> poulet<Icon type=" gt-inverted" /></>
                    }
                </Link>

            </div>

            <IngredientsSlider currentPage="chicken" {...props} />
            <MobileOrderBanner {...props} />

        </>

    )
}
export default Chicken;